
import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Form, Field} from 'react-final-form';
import { CardFormHorizontal } from '../../widgets/Cards';

import { editHADetail, newHADetail, fetchHADetails } from '../../../actions';

class HADetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            current_entry : null
        };
    };

    componentDidMount() {
        this.props.fetchHADetails(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchHADetails(this.props.patient._id)
        }    
    }

    formButton() {
        var permit = this.props.selectedPermission.permission[0].healthassessment;
        if (permit === "View only") {
            return "inaction";
        } else { 
            return "action";
        }  
    }
    
    HADetailForm() { 
        const all_contents = this.props.content;
        const last_entry = all_contents[(all_contents.length)-1];
        const content = last_entry;

        const handleSubmit = (formValues) => {
            const form = formValues;
                  
            form['patientId'] = this.props.patient._id;
            form['userId'] = this.props.userId;

        // Change Actions below
            this.props.newHADetail(form);
        }

        const required = value =>(value ? undefined : 'Required');

        const formButton = () => {
            var permit = this.props.selectedPermission.permission[0].healthassessment;
            if (permit === "View only") {
                return "visible";
            } else { 
                return "hidden";
            }  
        }

// SECTION A
        return (
            <Form
                onSubmit = {handleSubmit}
                initialValues = {content}
                render = {({handleSubmit, pristine, form, values, submitting}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <div className='header'>Detail</div>

                            <div className='form-4-columns'>
                                <Field name="date" component='input' label="Date" validate={required}>
                                    {({input, meta}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Date</label>
                                                <input size='30' {...input} type='date' />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                    )} 
                                </Field>
                                <Field name="consent" component='input'>
                                    {({ input}) => (
                                        <div>
                                            <label>Consent</label>
                                            <select {...input}>
                                                <option value="not obtained">Not obtained</option>
                                                <option value="by patient">By Patient</option>
                                                <option value="by patient">By MPOA</option>

                                            </select>
                                        </div>
                                    )}
                                </Field>
                                <Field name="consentdate" component='input' label="Date" validate={required}>
                                    {({input, meta}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Consent Date</label>
                                                <input size='30' {...input} type='date' />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                    )} 
                                </Field>
                                <Field name='consentby' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Name of person who provide consent</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='hospital' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Hospitalisation for the past year</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='medication' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Change of medications</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='condition' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Change of Condition</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='fall' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Falls for the past year</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='cognitive' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Cognitive Functioning</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='adl' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Activity of Daily Living</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='other' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Other</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='expertise' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Input from other Providers</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='carer' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Carer</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='mpoa' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Medical Power of Attorney</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='directive' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Advanced Directive</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='action' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Action to be done</label>
                                            <textarea cols="80" rows='3' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>

                            </div>

                            <div className={this.formButton()}>
                                <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                <button type='button' onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                            </div>
                        </form>
                    )
                }}
            />
        )
    }

    render() {
        return (
            <CardFormHorizontal content={this.HADetailForm()}>
            </CardFormHorizontal>
        )
    }
}


const mapStateToProps = (state) => {

    return { 
             patient : state.selectedPatient,
             content : Object.values(state.ha_details),
             userId : state.auth.userId,
             selectedPermission : state.selectedPermission,
            };
}

export default connect(mapStateToProps,{editHADetail, newHADetail, fetchHADetails})(HADetail);
